
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import * as React from "react";

type Props = {
  open: boolean;
  remainingMs?: number;
  onClose?: () => void;
  onContinue?: () => void;
  autoHideDuration?: number;
};

export const IdleWarningSnackbar: React.FC<Props> = ({
  open,
  remainingMs,
  onClose,
  onContinue,
  autoHideDuration,
}) => {
  const remainingSeconds =
    remainingMs != null ? Math.max(1, Math.round(remainingMs / 1000)) : undefined;

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      autoHideDuration={autoHideDuration}
      sx={{ mt: 2, mr: 2 }}
    >
      <Alert
        onClose={onClose}
        severity="warning"
        variant="filled"
        sx={{
          width: "100%",
          alignItems: "center",
          "& .MuiAlert-message": {
            display: "flex",
            alignItems: "center",
          },
          "& .MuiAlert-action": {
            display: "flex",
            alignItems: "center",
            alignSelf: "center",
          },
        }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={onContinue}
            aria-label="Continue session"
          >
            Continue session
          </Button>
        }
      >
        <Stack spacing={0.5}>
          <span>
            You have been inactive. The system will sign you out{" "}
            {remainingSeconds != null ? (
              <>
                in <b>{remainingSeconds}s</b>.
              </>
            ) : (
              <>soon.</>
            )}
          </span>
        </Stack>
      </Alert>
    </Snackbar>
  );
};
